import { Controller } from "@hotwired/stimulus"
import ApexCharts from "apexcharts/dist/apexcharts.min.js"

export default class extends Controller {
  static values = {
    options: Object,
    data: Object,
    cameraLabels: Object,
    yValues: Array,
    userIcon: String
  }

  connect() {
    const options = { ...this.optionsValue }

    options.yaxis = {
      min: Math.min(...this.yValuesValue),
      max: Math.max(...this.yValuesValue),
      tickAmount: this.yValuesValue.length - 1,
      labels: {
        formatter: (val) => {
          const key = String(Math.round(val))
          return this.cameraLabelsValue[key] || ""
        }
      }
    }

    options.xaxis = {
      type: "datetime",
      labels: {
        rotate: -45,
        formatter: (val) => {
          const date = new Date(val)
          return date.toLocaleString("en-US", {
            month: "short",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit"
          })
        }
      }
    }

    options.tooltip = {
      shared: true,
      intersect: false,
      custom: ({ dataPointIndex, w }) => {
        const labels = []
        const seriesNames = w.globals.seriesNames

        seriesNames.forEach((seriesName, i) => {
          const pointData = w.config.series[i].data[dataPointIndex]
          if (!pointData) return

          const point = this.dataValue[`${pointData.x}-${seriesName}`] || {}
          const date = new Date(pointData.x).toLocaleString("en-US", {
            month: "short",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit"
          })

          const img = point.image || "/images/default.jpg"
          const cameraName = point.camera_name || "Unknown Camera"
          const userName = point.user_name || "Unknown User"

          labels.push(`
            <div class="detaction-modal" style="padding:12px; text-align:center; border-radius:10px;
                        box-shadow:0 5px 7px #0000003D; width:280px; background:#fff; margin-bottom:10px;">
              <img src="${img}" width="250"
                  style="border-radius:20px; padding:10px; height:180px;" class="detaction-img"/>
              <div class="detaction-date" style="display:flex; justify-content: space-between; align-items: center;">
                <div style="text-align:left; font-size: 12px;">
                  <strong style="font-size:14px; font-weight:500; color:#141414;">${date}</strong><br/>
                  ${cameraName}
                </div>
                <div class="user-name" style="font-size:12px; font-weight: 500; color:#141414; display:flex; align-items:center; flex-wrap:wrap; white-space:wrap;">
                  <img src="${this.userIconValue}" style="margin-right:2px; width: 10px;" />
                  ${userName}
                </div>
              </div>
            </div>
          `)
        })

        return `<div>${labels.join("")}</div>`
      }
    }

    this.chart = new ApexCharts(this.element, options)
    this.chart.render()
  }

  disconnect() {
    if (this.chart) this.chart.destroy()
  }
}
